import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/sections/HeroSection';
import { Vision2030Section } from '../components/sections/Vision2030Section';
import { CredibilitySection } from '../components/sections/CredibilitySection';
import { LeadershipSection } from '../components/sections/LeadershipSection';
import { ContactSection } from '../components/sections/ContactSection';
import { SEOHead } from '../components/SEOHead';

export const HomePage: React.FC = () => {
  return (
    <div className="App font-arabic">
      <SEOHead 
        title="ضوء الخريج - وجهتك الأولى في رحلة التخصص" 
        description="منصة ضوء الخريج الرائدة في السعودية لمساعدة الطلاب في اختيار التخصص الجامعي المناسب. أكثر من 500 ألف طالب يثقون بخدماتنا. حمل التطبيق مجاناً."
        keywords="ضوء الخريج, اختيار التخصص, الجامعات السعودية, تطبيق تعليمي, استشارات مهنية, حساب المعدل, النسبة الموزونة"
        canonical="https://about.alkhreej.com/"
      />
      
      {/* Fixed Header */}
      <Header />
      
      {/* Main Content */}
      <main className="relative">
        {/* Hero Section */}
        <HeroSection />
        
        {/* Vision 2030 Alignment */}
        <Vision2030Section />
        
        {/* Institutional Credibility */}
        <CredibilitySection />
        
        {/* Leadership & Team */}
        <LeadershipSection />
        
        {/* Contact & Partnership */}
        <ContactSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};